import { DateListItem } from 'components/index'
import flowRight from 'lodash/flowRight'
import sortBy from 'lodash/sortBy'
import { makeSelectDates } from 'logic/dates'
import moment from 'moment'
import { Component, Fragment } from 'react'
import { FormattedDate } from 'react-intl'
import { connect } from 'react-redux'
import { createStructuredSelector } from 'reselect'

const MonthHeader = ({ date, renderYear }) => (
  <div className="month-header">
    <FormattedDate value={date} month="long" year={renderYear ? 'numeric' : undefined} />
  </div>
)
class DatesListing extends Component {

  renderDate = date => {
    const curMonth = moment(date.starts_at)
    const renderMonthHeader = !this.lastMonth || curMonth.month() !== this.lastMonth.month()
    const renderYear = !this.lastMonth || curMonth.year() !== this.lastMonth.year()
    this.lastMonth = curMonth
    return (
      <Fragment key={date.id}>
        {renderMonthHeader
          ? <MonthHeader date={this.lastMonth.toDate()} renderYear={renderYear} />
          : null
        }
        <DateListItem date={date} showMore={this.props.showMore} />
      </Fragment>
    )
  }

  render() {
    const { dates } = this.props
    this.lastMonth = null
    this.lastYear = null

    return (
      <div>
        {dates
          ? sortBy(dates, 'starts_at').map(date => this.renderDate(date)
            )
          : <Fragment>
              <DateListItem />
              <DateListItem />
              <DateListItem />
            </Fragment>
        }
      </div>
    )
  }

}

const mapStateToProps = createStructuredSelector({
  dates: makeSelectDates(),
});

const enhance = flowRight(
  connect(mapStateToProps),
)

export default enhance(DatesListing);
